import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Information Technology landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); the admin screens live inside
 * the Admin module. No "coming soon" note. The route is gated by dept.it in allRoutes.js.
 */
const MODULES = ["admin", "support", "app-orgchart", "app-visitors", "kpi"];

const IT = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-server-line"
                        eyebrow="Infrastructure"
                        title="Information Technology"
                        subtitle="Systems, accounts, and infrastructure"
                        tone="violet"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Information Technology" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="all" title="IT modules" icon="ri-shield-user-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default IT;
